import { type Point, point } from '../../../elements';
import { ICON_DEFAULT_FOREGROUND_COLOR } from '../../../graphConstants';
import { makeTag } from '../../../svg/utils';
import {
  type NodeIconOptions,
  type NodeTypeIcon,
  nodeIconDefaultOptions,
} from '../NodeTypeIcon';
import {
  createSquareNodeTypeIcon,
  getArrowSvgPath,
  wrapNodeIconInSvgTag,
} from '../common';
import { drawSquareBackground } from '../drawIconBackground';

const ICON_SIZE = 40;

function createWaasIcon(options: NodeIconOptions = {}): string {
  const opts = { ...nodeIconDefaultOptions, ...options };

  const drawArrow = (from: Point, to: Point) =>
    makeTag('path', {
      d: getArrowSvgPath({
        from,
        to,
        headWidth: 5.6,
        headHeight: 5.6,
        headSkew: 0.8,
        tailWidth: 1.6,
      }),
      fill: ICON_DEFAULT_FOREGROUND_COLOR,
    });

  const icon = `
    ${drawSquareBackground(ICON_SIZE, opts.style)}
    ${drawArrow(point.create(37.6, 20), point.create(27.6, 20))}
    ${drawArrow(point.create(3.6, 6.4), point.create(13.2, 13.2))}
    ${drawArrow(point.create(3.2, 20), point.create(12.8, 20))}
    ${drawArrow(point.create(3.6, 33.6), point.create(13.2, 26.8))}
    <polygon points="15.6 14 24.8 20 15.6 26" fill="${ICON_DEFAULT_FOREGROUND_COLOR}" />
  `;

  return wrapNodeIconInSvgTag(icon, ICON_SIZE, ICON_SIZE, 'topLeft', opts);
}

export const waasIcon: NodeTypeIcon = createSquareNodeTypeIcon(
  ICON_SIZE,
  createWaasIcon,
);
